import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { REQUEST_SKU } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { BILLING } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import { getUpgradeDataTrackingProperties } from '../../ums/utils';
import { UPGRADE_POINT_LOCATIONS } from '../common/constants/PurchaseMotionLocations';
import { jsx as _jsx } from "react/jsx-runtime";
function PricingPageInterstitialBuyContactsButton({
  'data-selenium-id': dataSeleniumId,
  'data-test-id': dataTestId,
  seleniumId,
  onClick,
  trackingSource,
  use,
  children,
  upgradeData,
  size,
  location,
  block
}) {
  const isUpgradePoint = location && UPGRADE_POINT_LOCATIONS.includes(location);
  const {
    screen,
    upgradeProduct
  } = upgradeData;
  const handleClick = event => {
    tracker.track('interaction', {
      action: 'clicked interstitial redirect',
      screen,
      upgradeProduct
    });
    if (isUpgradePoint) {
      tracker.track('interaction', Object.assign({
        action: 'clicked upgrade point'
      }, getUpgradeDataTrackingProperties(upgradeData)));
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
    adminType: BILLING,
    modalType: REQUEST_SKU,
    upgradeData: upgradeData,
    children: /*#__PURE__*/_jsx(Button, {
      "data-selenium-id": dataSeleniumId || `${trackingSource}-${seleniumId}-interstitial-confirm-contacts-button`,
      "data-test-id": dataTestId || `${trackingSource}-${seleniumId}-interstitial-confirm-contacts-button`,
      use: use,
      onClick: handleClick,
      target: "_blank",
      truncate: true,
      truncateStringProps: {
        justifyContent: 'center'
      },
      size: size,
      block: block,
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.pricingCtas.buyAdditionalContacts"
      })
    })
  });
}
export default PricingPageInterstitialBuyContactsButton;